import { useEffect, useState } from "react";

const hasIntersectionObserver = "IntersectionObserver" in window;

export default function useVisibility(node: HTMLElement, flagOnce?: boolean) {
  const [visible, setVisible] = useState<boolean>(false);

  useEffect(() => {
    const obs: IntersectionObserver | null =
      node && hasIntersectionObserver
        ? new IntersectionObserver((entries) => {
          const { isIntersecting } = entries[0];
          if (entries.length === 1) {
            setVisible(isIntersecting);
            if (flagOnce && isIntersecting) {
              obs?.disconnect();
            }
          }
        })
        : null;
    obs?.observe(node);

    return () => {
      obs?.disconnect();
    };
  }, [flagOnce, node]);

  return visible;
}
